import { Fork, Invoke } from '@swf/components/StarsWizard/Flow';
import useWizardExit from '@swf/core/hooks/useWizardExit';
import type { FlowConfig } from '@swf/core/types/Wizard';
import { Action } from '@swf/core/types/Wizard';

import RMFAddress from '../components/RMFAddress/RMFAddress';
import RMFGender from '../components/RMFGender/RMFGender';
import RMFIdentityVerification from '../components/RMFIdentityVerification/RMFIdentityVerification';
import RMFLegalName from '../components/RMFLegalName/RMFLegalName';
import RMFStandaloneFinalPage from '../components/RMFStandaloneFinalPage/RMFStandaloneFinalPage';

import useRMFBaseSteps from './useRMFBaseSteps';
import { Guard } from './useRmfGuards';
import { Service } from './useRmfServices';

const useRmfDKFlow = (): FlowConfig => {
  const exitWizard = useWizardExit();

  const jumpToFeatureStep = {
    name: 'jumpToFeatureStep',
    entry: Action.GoJump
  };

  const { forkSignupDepositCheckDone } = useRMFBaseSteps();

  const forkJumpToFeature = new Fork(
    Guard.DoesJumpToFeatureStep,
    [new Invoke(Service.SetJumpCreator, jumpToFeatureStep)],
    [forkSignupDepositCheckDone]
  );

  const forkRmfExit = new Fork(
    Guard.StandaloneRmf,
    [
      RMFStandaloneFinalPage,
      {
        name: 'exitRMF',
        entry: exitWizard,
        type: 'final'
      }
    ],
    [forkJumpToFeature]
  );

  const invokeEnableRealMoneyFlag = new Invoke(
    Service.RmfEnableRealMoneyFlagDK,
    forkJumpToFeature,
    RMFIdentityVerification
  );

  const invokeLegalNameSave = new Invoke(Service.RmfLegalNameSave, RMFGender, RMFLegalName);
  const invokeGenderSave = new Invoke(Service.RmfGenderSave, RMFAddress, RMFGender);
  const invokeAddressSave = new Invoke(Service.RmfAddressSave, RMFIdentityVerification, RMFAddress);

  const invokeIdentityVerificationSave = new Invoke(
    Service.RmfIdentifyVerificationSavePT,
    invokeEnableRealMoneyFlag,
    RMFIdentityVerification
  );

  return [
    RMFLegalName,
    invokeLegalNameSave,
    RMFGender,
    invokeGenderSave,
    RMFAddress,
    invokeAddressSave,
    RMFIdentityVerification,
    invokeIdentityVerificationSave,
    invokeEnableRealMoneyFlag,
    forkRmfExit,
    jumpToFeatureStep
  ];
};
export default useRmfDKFlow;
